import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'utcToHonduras',
  standalone: true,
})
export class UtcToHondurasPipe implements PipeTransform {
  transform(value: string | Date | null | undefined, format: 'short' | 'medium' | 'long' = 'medium'): string {
    if (!value) return '';

    try {
      const date = typeof value === 'string' ? new Date(value) : value;

      if (isNaN(date.getTime())) {
        return '';
      }

      // Honduras is in Central America Time (UTC-6)
      const options: Intl.DateTimeFormatOptions = {
        timeZone: 'America/Tegucigalpa',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
      };

      if (format === 'medium' || format === 'long') {
        options.hour = '2-digit';
        options.minute = '2-digit';
      }

      if (format === 'long') {
        options.second = '2-digit';
      }

      return date.toLocaleString('es-HN', options);
    } catch (error) {
      console.error('Error formatting date:', error);
      return '';
    }
  }
}
